import { useMemo } from "react";
import useSWR from "swr";
import { useSimpleRegistrationContext } from "pages/SimpleRegistrationsPage";
import { useApi } from "providers/ApiProvider";
import { Box as MuiBox, styled as muiStyled } from "@mui/material";
import { DialButton } from "./DialButton";
import { PurposeItem } from "~/core/resources/registrationApi";

const Box = muiStyled(MuiBox)`
  &.container {
    width: 100%;
    height: 100%;
  }

  &.content {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    padding: 3%;
  }

  &.title {
    font-size: 4vw;
    font-weight: bold;
    margin-bottom: 40px;

    b {
      font-weight: 800;
    }
  }

  &.buttons-container {
    display: flex;
    flex-direction: column;
    gap: 5vw;
  }

  &.button-row {
    display: flex;
    justify-content: space-between;
  }

  &.button-text {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

export const PortraitVisitPurposeSelect = () => {
  const { visitPurpose, setVisitPurpose } = useSimpleRegistrationContext();
  const { registrationApi } = useApi();
  const { data } = useSWR("visit-purpose", async () => {
    const response = await registrationApi.purposeList({
      limit: 12,
      visible: true,
      orderBy: "order desc",
    });
    return response.data || [];
  });

  const visitPurposeList = useMemo(() => {
    return data?.data || [];
  }, [data]);

  const onClickSelect = (purpose: PurposeItem) => {
    if (visitPurpose.indexOf(purpose) > -1) {
      const update = [...visitPurpose];
      update.splice(visitPurpose.indexOf(purpose), 1);
      setVisitPurpose(update);
    } else {
      const update = [...visitPurpose];
      update.push(purpose);
      setVisitPurpose(update);
    }
  };

  const VisitPurposesButtons = () => {
    const buttons = visitPurposeList.map((v) => (
      <DialButton
        key={v.id}
        text={v.name}
        disabled={visitPurpose.indexOf(v) === -1 && visitPurpose.length === 3}
        onClick={() => onClickSelect(v)}
        selected={visitPurpose.indexOf(v) > -1}
      />
    ));
    const divList = [];
    for (let i = 0; i < buttons.length; i += 2) {
      divList.push(
        <Box className="button-row" key={i}>
          {buttons.slice(i, i + 2)}
        </Box>
      );
    }
    return <>{divList}</>;
  };

  return (
    <Box className="container">
      <Box className="content">
        <Box className="title">
          <b>방문목적</b>를 선택하세요 (최대 3개)
        </Box>
        <Box className="buttons-container">
          <VisitPurposesButtons />
        </Box>
      </Box>
    </Box>
  );
};
